export default class Localization {
	de: string;
	en: string;
	fr?: string;
	nl?: string;
	it?: string;
	pl?: string;
	es?: string;
}
